import { Box, BoxProps } from "@chakra-ui/react";
import CopyButton from "components/Shared/CopyButton";
import Link, { LinkProps } from "components/Shared/Link";
import { ReactNode } from "react";

function defaultRenderValue(value: string) {
  return <Box isTruncated>{value}</Box>;
}

export function makeRenderValueAsLink(
  renderer: (value: string) => ReactNode,
  props: LinkProps,
) {
  return function renderValue(value: string) {
    return <Link {...props}>{renderer(value)}</Link>;
  };
}

export type Props = BoxProps & {
  renderValue?: (value: string) => React.ReactNode;
  tooltipLabel?: string;
  value: string;
};

export default function CopyableValue({
  renderValue = defaultRenderValue,
  tooltipLabel = "Copy",
  value,
  ...rest
}: Props) {
  return (
    <Box
      as="span"
      display="inline-flex"
      alignItems="baseline"
      whiteSpace="nowrap"
      {...rest}
    >
      {renderValue(value)}

      <CopyButton
        label={tooltipLabel}
        value={value}
        fontSize=".85em"
        ml=".25em"
        my="-.25em"
        tooltipProps={{ placement: "bottom" }}
      />
    </Box>
  );
}
